import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=5efe53c4&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=ts&"
export * from "./UserList.vue?vue&type=script&lang=ts&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=5efe53c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe53c4",
  null
  
)

export default component.exports